var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',[_c('div',[_c('a',{attrs:{"href":"https://coreui.io","target":"_blank"}},[_vm._v("SOS click")]),_c('span',{staticClass:"ml-1"},[_vm._v("© 2020 Natural Phone.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }